export const getAdjustedColorOpacity = (colorInHex: string, opacityPercentage: number): string => {
  const hex = colorInHex.replace('#', '');
  const hexBigInt = parseInt(hex, 16);
  const r = (hexBigInt >> 16) & 255;
  const g = (hexBigInt >> 8) & 255;
  const b = hexBigInt & 255;
  return `rgb(${r}, ${g}, ${b}, ${opacityPercentage})`;
};

/** Dark or white text color for legibility on top of `colorInHex`; falls back to dark for non 6-digit hex. */
export const readableTextColor = (colorInHex: string): string => {
  const hex = colorInHex.replace('#', '');
  if (hex.length !== 6) return '#1a1b1e';
  const hexBigInt = parseInt(hex, 16);
  const r = (hexBigInt >> 16) & 255;
  const g = (hexBigInt >> 8) & 255;
  const b = hexBigInt & 255;
  const luminance = (0.299 * r + 0.587 * g + 0.114 * b) / 255;
  return luminance > 0.6 ? '#1a1b1e' : '#ffffff';
};

// Excludes kiloBlue (reserved for primary actions/branding) and red (reserved for
// destructive/error states) so avatar colors never get confused for either.
const AVATAR_COLOR_PALETTE = ['cyan', 'grape', 'green', 'indigo', 'orange', 'pink', 'teal', 'violet'];

/** Deterministic Mantine color name for a person's avatar, stable across renders for the same `seed` (e.g. an athlete ID). */
export const getAvatarColor = (seed: string): string => {
  let hash = 0;
  for (let i = 0; i < seed.length; i += 1) {
    hash = (hash << 5) - hash + seed.charCodeAt(i);
    hash |= 0;
  }
  return AVATAR_COLOR_PALETTE[Math.abs(hash) % AVATAR_COLOR_PALETTE.length];
};
